import { Size, Sizes, UITheme, UIThemes } from '@agilox/ui-common';
import { Component, computed, input } from '@angular/core';
import { SpinnerVariantClasses } from './spinner.config';

@Component({
	selector: 'ui-spinner',
	templateUrl: './spinner.component.html',
})
export class SpinnerComponent {
	color = input<UITheme>(UIThemes.Primary);
	inline = input<boolean>(false);
	inverted = input<boolean>(false);
	size = input<Extract<Size, 'xs' | 's' | 'm' | 'l'>>('m');
	inlineCompact = input<boolean>(false);

	baseClasses = computed(() => {
		const base =
			'opacity-100 transition-opacity before:absolute before:left-1/2 before:top-1/2 before:border-solid before:rounded-full before:animate-spinner before:transform before:will-change-transform';

		if (this.inlineCompact()) {
			return `${base} inline-block relative shrink-0`;
		}

		if (this.inline()) {
			return `${base} inline-block relative shrink-0 h-full w-full`;
		}

		return `${base} h-full w-full`;
	});

	sizeClass = computed(() => {
		switch (this.size()) {
			case Sizes.XS:
				return 'h-3.5 w-3.5 before:w-3.5 before:h-3.5 before:border';
			case Sizes.S:
				return 'h-6 w-6 before:w-6 before:h-6 before:border';
			case Sizes.M:
				return 'h-8 w-8 before:w-8 before:h-8 before:border-[1.5px]';
			case Sizes.L:
				return 'h-12 w-12 before:h-12 before:w-12 before:border-2';
		}
	});

	variantClasses = computed(() => {
		const variant = this.inverted()
			? SpinnerVariantClasses.Inverted
			: SpinnerVariantClasses.Default;
		return variant[this.color()];
	});
}
